import type {
    MutableMaterializedResource,
} from '@toolproof-core/lib/_contract/workflow-overlay';

import type { EntityItem } from '@toolproof-core/visualization/_contract/item';

const ENTITY_ITEM_KEY_PREFIX = 'item:entity:';
const TOOL_STEP_HANDLE_PREFIX = 'TOOL_STEP-';

export function parseToolStepKeyFromItemKey(itemKey: EntityItem['itemKey']): string | null {
    if (!itemKey.startsWith(ENTITY_ITEM_KEY_PREFIX)) return null;

    const encodedStepKey = itemKey.slice(ENTITY_ITEM_KEY_PREFIX.length);
    if (!encodedStepKey) return null;

    const stepKey = decodeURIComponent(encodedStepKey);
    return stepKey.startsWith(TOOL_STEP_HANDLE_PREFIX) ? stepKey : null;
}

export function toProjectionText(entry: MutableMaterializedResource | null): string | null {
    if (!entry) return null;

    const projection = entry.projection;
    if (typeof projection === 'string' || typeof projection === 'number' || typeof projection === 'boolean') {
        return String(projection);
    }

    return null;
}